import classnames from "classnames";
import { useEffect, useState } from "react";
import { NavLink } from "../../../components/NavLink";
import tenantApi from "@/api/tenant";
import { AdminListHeader } from "@/pages/Admin/AdminListHeader";
import { sortByField } from "@/pages/Admin/utils/sortByField";
import { ITenant } from "@/types/tenant";

export const Tenants = () => {
    const [tenants, setTenants] = useState<ITenant[]>([]);

    useEffect(() => {
        const getAllTenants = async () => {
            const response = await tenantApi.getTenants();
            setTenants(sortByField(response, "subdomain"));
        };
        getAllTenants();
    }, []);

    return (
        <div className="px-4 sm:px-6 lg:px-8">
            <AdminListHeader
                title="Tenants"
                description="A list of all the tenants"
                buttonText="Add Tenant"
                to="new"
            />
            <div className="mt-8 flow-root">
                <div className="-mx-4 -my-2 sm:-mx-6 lg:-mx-8">
                    <div className="inline-block min-w-full py-2 align-middle">
                        <table className="min-w-full border-separate border-spacing-0">
                            <thead>
                                <tr>
                                    <th
                                        scope="col"
                                        className="sticky top-0 z-10 border-b border-gray-300 bg-white bg-opacity-75 py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter sm:pl-6 lg:pl-8"
                                    >
                                        ID
                                    </th>
                                    <th
                                        scope="col"
                                        className="sticky top-0 z-10 border-b border-gray-300 bg-white bg-opacity-75 py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter sm:pl-6 lg:pl-8"
                                    >
                                        Name
                                    </th>

                                    <th
                                        scope="col"
                                        className="sticky top-0 z-10 border-b border-gray-300 bg-white bg-opacity-75 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter"
                                    >
                                        Subdomain
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {tenants &&
                                    tenants.map((tenant, tenantIdx) => (
                                        <tr key={tenant.id}>
                                            <td
                                                className={classnames(
                                                    tenantIdx !==
                                                        tenants.length - 1
                                                        ? "border-b border-gray-200"
                                                        : "",
                                                    "whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 lg:pl-8",
                                                )}
                                            >
                                                <NavLink
                                                    href={`${tenant.id}`}
                                                    className="text-primary-600 hover:text-primary-900"
                                                >
                                                    {tenant.id}
                                                </NavLink>
                                            </td>
                                            <td
                                                className={classnames(
                                                    tenantIdx !==
                                                        tenants.length - 1
                                                        ? "border-b border-gray-200"
                                                        : "",
                                                    "whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 lg:pl-8",
                                                )}
                                            >
                                                <NavLink
                                                    href={`${tenant.id}`}
                                                    className="text-primary-600 hover:text-primary-900"
                                                >
                                                    {tenant.name}
                                                </NavLink>
                                            </td>

                                            <td
                                                className={classnames(
                                                    tenantIdx !==
                                                        tenants.length - 1
                                                        ? "border-b border-gray-200"
                                                        : "",
                                                    "whitespace-nowrap px-3 py-4 text-sm text-gray-500",
                                                )}
                                            >
                                                {tenant.subdomain}
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};
